import {kebabCase} from 'lodash'

export function layout (layout = 'Default', children, path = '', meta) {
    const dir = kebabCase(layout)

    return {
        children,
        component: () => import(
            `@/layouts/${dir}/Index`
            ),
        path,
        meta
    }
}
export function redirect (
    path = '*',
    rpath,
) {
    return {
        path,
        redirect: rpath
    }
}
export function route (name, component, path = '', meta, redirect) {
    component = Object(component) === component
        ? component
        : { default: name.replace(' ', '') }

    const components = {}

    for (const [key, value] of Object.entries(component)) {
        components[key] = () => import(
            `@/views/${value}`
            )
    }

    return {
        name,
        components,
        path,
        meta,
        redirect
    }
}
